import React, {memo, useEffect} from 'react'
import cx from 'classnames'

/* Constants */
import {FEATURE_TOGGLE_NAMES} from '../../../../modules/feature-toggle/featureToggleConstants'
import {DESKTOP_COMPONENTS, DESKTOP_COMPONENTS_OPTIONS} from '../../../../modules/voltran/voltranConstants'

/* Components */
import VoltranFragment from '../../../../components/VoltranFragment/VoltranFragment'
import HbPlaceholderFrame from '../../../../components/Placeholder/frame/HbPlaceholderFrame'

/* Hooks */
import {useEffectOnlyOnUpdate} from '../../../../common/react/hook/lifecycle'

/* Utils */
import {generatePremiumContentRequest} from '../../../../modules/product/productDesktopUtils'
import {resolveWithSettleContext} from '../../../../common/async/promiseUtils'

/* Actions */
import {actionCreators as voltranActionCreators} from '../../../../redux/actions/voltranActions'

/* Styles */
import s from './premium-content.scss'

const PREMIUM_LOAD_EVENT = 'OneClickPDPTouchPoint'

const PremiumContent = memo(({
  fragmentInfo,
  options,
  className,
  sku,
  premiumContentRequestPayload,
  isVisible,
  pageFeatureToggleMap,
  fragmentsMap,
  dispatch,
  isGetCampaignsPdpDashboardPending
}) => {
  useEffect(() => {
    if (!isGetCampaignsPdpDashboardPending) {
      setTimeout(() => {
        fetchPremiumContent()
      }, 500)
    }

    window?.HbEventBus?.on(PREMIUM_LOAD_EVENT, (data) => {
      if (window?.Loyalty?.fetchAdvantagesByProduct) {
        window.Loyalty.fetchAdvantagesByProduct?.(premiumContentRequestPayload)
      }
    })

    return () => {
      window?.HbEventBus?.off(PREMIUM_LOAD_EVENT, false)
    }
  }, [])

  useEffectOnlyOnUpdate(() => {
    if (isVisible) {
      generatePremiumContentRequest(premiumContentRequestPayload)
    }
  }, [sku, isVisible])

  const fetchPremiumContent = () => {
    const fragments = []
    if (pageFeatureToggleMap?.get(FEATURE_TOGGLE_NAMES.IS_DISPLAY_LOYALTY_PREMIUM_ON_PDP) && !fragmentsMap?.get(DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.PREMIUM_BANNER]?.id?.toString())) {
      fragments.push({
        ...DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.PREMIUM_BANNER],
        paramater: {
          ...DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.PREMIUM_BANNER].paramater,
          ...premiumContentRequestPayload
        }
      })
    }

    if (fragments?.length > 0) {
      resolveWithSettleContext(
        dispatch(
          voltranActionCreators.getFragments.trigger(fragments),
        )
      )
    }
  }

  return (
    <div className={cx(s.root, className, {[s.hide]: !isVisible})} data-test-id={'premium-content'}>
      {
        fragmentInfo ? (
          <VoltranFragment
            fragmentInfo={fragmentInfo}
            options={options}/>
        ) : (
          <HbPlaceholderFrame
            className={s.placeholder}
            contentClassName={s.placeholderContent}
            ratio={1}/>
        )}
    </div>
  )
})

export default PremiumContent
